module.exports = __webpack_public_path__ + "img/diamond.22a26930.webp";